import { LatLngTuple } from "leaflet"

export const machineImageURL = '/public/img/logo/pgs/logo.svg'

export const squareLogo = '/public/env/img/logo/logo-1-1.png'

export const anonCanAddFailure = true

export const defaultMapCenter:LatLngTuple  = [
    52.23192,
    21.0138606
]